import React from "react";
import { Skeleton, Card } from "antd";

const AssigneeSectionSkeleton: React.FC = () => {
  return (
    <div className="assignee-details-frame">
      {/* Assignee header */}
      <div className="header-wrapper flex flex-col gap-4">
        <Skeleton.Input style={{ width: 120 }} active />
        <Skeleton.Input style={{ width: 200, height: 32 }} active />
      </div>

      {/* Activity log */}
      <div className="activity-log-frame mt-6">
        <Skeleton.Input style={{ width: 140 }} active />
        <div className="flex flex-col gap-3 mt-3">
          {[1, 2, 3].map((i) => (
            <Card key={i} style={{ padding: 12 }}>
              <Skeleton paragraph={{ rows: 1 }} active />
              <Skeleton.Input style={{ width: 100, marginTop: 8 }} active />
            </Card>
          ))}
        </div>
      </div>

      {/* Relationships / Merged tickets */}
      <div className="tickets-relationships-wrapper mt-6">
        <Skeleton.Input style={{ width: 140 }} active />
        <div className="flex gap-2 mt-3">
          {[1, 2].map((i) => (
            <Skeleton.Input key={i} style={{ width: 100, height: 32 }} active />
          ))}
        </div>
      </div>

      {/* Primary ticket card */}
      <div className="primary-ticket-card mt-6">
        <Skeleton.Input style={{ width: "100%", height: 40 }} active />
        <Skeleton paragraph={{ rows: 3, width: "100%" }} active />
      </div>
    </div>
  );
};

export default AssigneeSectionSkeleton;
